var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardano(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 463.672 463.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0033ad;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 231.836,
    cy: 231.836,
    r: 231.836,
    transform: "translate(-96.03 231.836) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.977,230.777a20.557,20.557,0,0,0,19.325,21.7h1.121a20.514,20.514,0,1,0-20.5-21.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.483,225.575a6.652,6.652,0,1,0,.032,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.676,111.721a6.743,6.743,0,1,0-.045.022Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.492,148.017a10.278,10.278,0,1,0-.006,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.444,172.98a8.441,8.441,0,1,0-2.415-11.69l-.006.01A8.441,8.441,0,0,0,112.444,172.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.92,221.843a10.245,10.245,0,1,0,9.652,10.817A10.245,10.245,0,0,0,124.92,221.843Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M113.565,290.725a9.023,9.023,0,1,0,.007,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.392,200.668a12.145,12.145,0,1,0-.021-.014Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M279.746,147.21a10.345,10.345,0,1,0-.027-.018Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.775,111.026a6.636,6.636,0,1,0-1.912-9.188l0,.007A6.637,6.637,0,0,0,300.775,111.026Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.36,211.25a20.519,20.519,0,1,0-2.354,40.97h1.188a20.512,20.512,0,0,0,15.29-34.177A20.263,20.263,0,0,0,281.36,211.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.229,199.244a20.525,20.525,0,1,0-2.173-9.157A20.435,20.435,0,0,0,189.229,199.244Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M350.086,172.958a8.441,8.441,0,1,0-11.344-3.744A8.44,8.44,0,0,0,350.086,172.958Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.062,179.493a12.086,12.086,0,1,0,.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.052,107.932a8.441,8.441,0,1,0-7.947-8.907v.006A8.441,8.441,0,0,0,231.052,107.932Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M230.962,161.054A12.062,12.062,0,1,0,219.6,148.32,12.063,12.063,0,0,0,230.962,161.054Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.611,284.179a12.061,12.061,0,1,0-16.2-5.34l0,0A12.062,12.062,0,0,0,165.611,284.179Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.753,178.652a20.513,20.513,0,1,0,17.184-9.27A20.513,20.513,0,0,0,238.753,178.652Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.421,264.439a20.513,20.513,0,1,0-18.316,29.75,20.742,20.742,0,0,0,9.237-2.242A20.524,20.524,0,0,0,274.421,264.439Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.269,263a12.061,12.061,0,1,0,3.464,16.7A12.061,12.061,0,0,0,310.269,263Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M349.547,232.189a10.245,10.245,0,1,0-10.817,9.651A10.244,10.244,0,0,0,349.547,232.189Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M377.93,224.892a6.636,6.636,0,1,0,6.244,7.006h0A6.647,6.647,0,0,0,377.93,224.892Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M351.207,290.691a8.441,8.441,0,1,0,2.432,11.692,8.441,8.441,0,0,0-2.432-11.692Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.887,352.646a6.636,6.636,0,1,0,1.906,9.192,6.637,6.637,0,0,0-1.906-9.192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.974,351.951a6.636,6.636,0,1,0,8.913,2.939v0a6.626,6.626,0,0,0-8.894-2.946Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.9,284.986a20.513,20.513,0,1,0-17.173,9.27A20.514,20.514,0,0,0,224.9,284.986Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.905,316.473a10.246,10.246,0,1,0,2.959,14.191A10.247,10.247,0,0,0,183.905,316.473Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.736,355.74a8,8,0,1,0,.005,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.825,302.63a12.061,12.061,0,1,0,11.308,12.77l0-.048A12.049,12.049,0,0,0,231.825,302.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.158,315.655a10.257,10.257,0,1,0,13.788,4.506l-.011-.022a10.235,10.235,0,0,0-13.759-4.493Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardano);
export default __webpack_public_path__ + "static/media/cardano.b909f204bcb0d0e590c54591941817b5.svg";
export { ForwardRef as ReactComponent };